export const FLOATING_DRAWER_ARROW_WIDTH = 20;
export const FLOATING_DRAWER_ARROW_HEIGHT = 20;
export const FLOATING_DRAWER_ARROW_OVERLAP_DRAWER = 7;
